import React from 'react';
import { defineMessages } from 'react-intl';
import Confirm from 'components/Confirm';
import Message from 'components/Message';

const COMMUNITY_GUIDELINES_LINK = 'https://classpass.com/about/community-standards';

const messages = defineMessages({
  title: {
    id: 'ratings.report-review-confirmation-modal.title',
    defaultMessage: 'Are you sure you want to report this review?',
  },
  body: {
    id: 'ratings.report-review-confirmation-modal.body',
    defaultMessage:
      'Please only report reviews that contain content that violates our <a>Community Guidelines</a>. Otherwise consider posting a reply instead.',
  },
  cancel: {
    id: 'ratings.report-review-confirmation-modal.cancel',
    defaultMessage: 'Cancel',
  },
  report: {
    id: 'ratings.report-review-confirmation-modal.report',
    defaultMessage: 'Report',
  },
});

const ReportReviewConfirmationModal = props => (
  <Confirm
    title={<Message message={messages.title} />}
    cancelNode={<Message message={messages.cancel} />}
    acceptNode={<Message message={messages.report} />}
    {...props}>
    <Message
      message={messages.body}
      values={{
        a: text => (
          <a href={COMMUNITY_GUIDELINES_LINK} rel="noopener noreferrer" target="_blank">
            {text}
          </a>
        ),
      }}
    />
  </Confirm>
);

export default ReportReviewConfirmationModal;
